/**
 *
 * Records Page
 *
 */
import Select from "react-select"
import React, { useState, useEffect } from "react"
import * as nightshiftAction from "../../store/TmlnaHRz/actions"
import MetaTags from "react-meta-tags"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Spinner,
  // CardTitle
} from "reactstrap"
import ButtonSpinner from "../../components/ButtonSpinner"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { useSelector, useDispatch } from "react-redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
//Import Styles
import "./styles.scss"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
// import { styles } from "../../pages/ClientDetails/Input-Select/select"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import moment from "moment"
import * as delegationAction from "../../store/RGVsZWdh/actions"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
// import { CSVExport } from "react-bootstrap-table2-toolkit"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import api from "../../helpers/Api"
import { toast, ToastContainer } from "react-toastify"
//import { deleteNightshift } from "store/TmlnaHRz/remotes"

const NightShiftDetails = (props) => {
  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()
  const mode = "hrms"

  useEffect(() => {
    dispatch(nightshiftAction.loadRecordsMetaData())
    dispatch(nightshiftAction.loadEmployee())
    dispatch(nightshiftAction.loadNightShiftDetail({ page: 1, limit: 25 }))
    dispatch(delegationAction.loadProcessStatus(mode))
  }, [1])

  const update = useSelector((specificstate) => specificstate)
  console.log("update is", update)

  const nightshiftUpdate = useSelector(
    (specificstate) => specificstate.nightshift
  )
  const {
    recordsMetaData = {},
    employee_list = [],
    nightshift_applies = [],
  } = nightshiftUpdate
  console.log("nightshiftUpdate is", nightshiftUpdate)
  console.log("nightshift_applies", nightshift_applies)

  // Access list
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Access start
  const loginAccess = !isEmpty(user) && user ? user : []
  const shiftMenuDetails =
    !isEmpty(loginAccess) && loginAccess.menu
      ? loginAccess.menu.filter(
          (menu) => menu.menuId._id === "62417d99ce2eb68383527cfa"
        )
      : []
  console.log(shiftMenuDetails, "shiftMenuDetails")

  const menuDetails =
    !isEmpty(shiftMenuDetails) && shiftMenuDetails.length > 0
      ? shiftMenuDetails.map((menu) => menu.menuId.menuSubHeader)
      : []

  const accessIdDetails =
    !isEmpty(menuDetails) && menuDetails.length > 0
      ? menuDetails[0].filter(
          (data) =>
            data._id === "6391ff585480a0031bad84a7" ||
            data._id === "63c9638651f9e62d6128a458" ||
            data._id === "63443344686501ccce051878"
        )
      : []

  const shiftRequestMenuDetails =
    !isEmpty(accessIdDetails) && accessIdDetails.length > 0
      ? accessIdDetails.map((data) => data.menuId.menuItem)
      : []
  const shiftRequestDetails =
    !isEmpty(shiftRequestMenuDetails) && shiftRequestMenuDetails.length > 0
      ? shiftRequestMenuDetails[0].filter(
          (data) => data.menuId._id === "63411375559b0440028a9ae9"
        )
      : []

  const accessDetails =
    !isEmpty(shiftRequestDetails) && shiftRequestDetails.length > 0
      ? shiftRequestDetails.map((menu) => menu.access)
      : []

  //shift Edit Access

  const shiftEditRoleAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
          (data) => data._id === "61bc3037e2e60e99196975fe"
        )
      : []

  const shiftEditAccessId =
    !isEmpty(shiftEditRoleAccess) && shiftEditRoleAccess.length > 0
      ? shiftEditRoleAccess[0]._id
      : []
  //shift Delete Access
  const shiftDeleteRoleAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
          (data) => data._id === "61bc3056e2e60e9919697601"
        )
      : []

  const shiftDeleteAccessId =
    !isEmpty(shiftDeleteRoleAccess) && shiftDeleteRoleAccess.length > 0
      ? shiftDeleteRoleAccess[0]._id
      : []
  //shift Role Access
  const shiftRoleAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
          (data) => data._id === "63f346383a0fac2651611d92"
        )
      : []

  const shiftRoleAccessId =
    !isEmpty(shiftRoleAccess) && shiftRoleAccess.length > 0
      ? shiftRoleAccess[0]._id
      : []
  console.log(shiftRequestDetails, "shiftRequestDetails")
  console.log(shiftRequestMenuDetails, "shiftRequestMenuDetails")
  console.log(menuDetails, "menuDetails")
  console.log(accessDetails, "accessDetails")
  console.log(shiftEditAccessId, "shiftEditAccessId")
  console.log(shiftDeleteAccessId, "shiftDeleteAccessId")
  console.log(shiftRoleAccessId, "shiftRoleAccessId")
  console.log(accessIdDetails, "accessIdDetails")

  //Apply lead modal Data
  //Apply leave modal
  const [applyShiftModal, setApplyShiftModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const handleShiftModal = () => setApplyShiftModal(false)

  const [confirmModalView, setConfirmModalView] = useState(false)
  const handleConfirmModal = () => setConfirmModalView(false)

  const [empCodeData, setEmpCodeData] = useState([])
  const [shiftAttachment, setShiftAttachment] = useState([])
  const [nigthShiftApplyData, setNightShiftApplyData] = useState({
    company: "",
    branch: "",
    designation: "",
    client: "",
    volume: "",
    department: "",
    permissionDate: "",
    fromTime: "",
    toTime: "",
    purpose: "",
  })
  const handleleaveChange = (e) => {
    setNightShiftApplyData({
      ...nigthShiftApplyData,
      [e.target.name]: e.target.value,
    })
  }

  const employeeChange = (e) => {
    setEmpCodeData(e)

    console.log(e, "empCode")

    nigthShiftApplyData.company = e ? e.companyName : ""
    nigthShiftApplyData.branch = e ? e.branchName : ""
    nigthShiftApplyData.department = e ? e.departmentName : ""
    nigthShiftApplyData.designation = e ? e.designationName : ""

    setNightShiftApplyData(nigthShiftApplyData)
  }
  console.log(empCodeData, "employeeCode Data")
  //Apply leave modal end

  const [NightShiftData, setNightShiftData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: [],
    fromDate: "",
    toDate: "",
    nightShiftStatus: [],
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentlist, setDepartmentlist] = useState([])
  const [employeeCode, setEmployeeCode] = useState([])
  const [nightShiftStatus, setNightShiftStatus] = useState([])
  // modal
  const [openModal, setOpenModal] = useState(false)
  const handleModal = () => setOpenModal(false)
  //dropdown options api
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.companyName = element.companyName
        obj.branchId = element.branchId
        obj.branchName = element.branchName
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)
  const employeeCodeOptions = createOptions(employeeList)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //checking
  const company = !isEmpty(companies) && companies.value
  const branch = !isEmpty(branches) && branches.value
  const department = !isEmpty(departmentlist) && departmentlist.value
  const employee = !isEmpty(employeeCode) && employeeCode.value
  const startDate = NightShiftData.fromDate
  const endDate = NightShiftData.toDate

  console.log(
    company,
    branch,
    department,
    employee,
    startDate,
    endDate,
    "dropdown outputs"
  )
  // Process Status
  const processUpdate = useSelector((specificstate) => specificstate.delegation)
  const { process_status = [] } = processUpdate
  console.log(process_status, "process_status")

  const processStatusList =
    !isEmpty(process_status) &&
    process_status.map((process) => {
      return {
        _id: process._id,
        colorCode: process.colorCode,
        description: process.description,
        mode: process.mode,
        processStatus: process.processStatus,
        processStatusId: process.processStatusId,
        shortCode: process.shortCode,
      }
    })

  const createProcessOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        ;(obj.value = element._id),
          (obj.label = element.processStatus),
          (obj.colorCode = element.colorCode),
          (obj.mode = element.mode),
          (obj.processStatusId = element.processStatusId),
          options.push(obj)
      })
    return options
  }

  const processStatusOptions = createProcessOptions(processStatusList)
  const updateProcessStatus = createProcessOptions(processStatusList)
  const nightshiftstatusOptions = createProcessOptions(processStatusList)

  const [requestStatus, setRequestStatus] = useState("")
  const updateProcessStatusOptions =
    !isEmpty(updateProcessStatus) &&
    updateProcessStatus.filter((process) => {
      return process.label !== requestStatus
    })

  console.log(processStatusOptions, "processStatus")
  const [btnLoader, setBtnLoader] = useState(false)
  const handleChange = async (e) => {
    setNightShiftData({ ...NightShiftData, [e.target.name]: e.target.value })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  console.log(pageCount, "pageCount")
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        page: pageChange ? pageCount : 1,
        limit: 25,
      }
      const branchValue = !isEmpty(branches)?branches.map(m=>m.value):""
  // filter section
  const handleFilter = () => {
    var searchCompany = companies && companies.value ? [companies.value] : ""
   
    var searchBranch  = branchValue
    var searchDepartment =
      departmentlist && departmentlist.value ? [departmentlist.value] : ""
    var searchEmployee =
      employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
    var searchFromDate =
      NightShiftData && NightShiftData.fromDate ? NightShiftData.fromDate : ""
    var searchToDate =
      NightShiftData && NightShiftData.toDate ? NightShiftData.toDate : ""
    var searchStatus =
      nightShiftStatus && nightShiftStatus.processStatusId
        ? nightShiftStatus.processStatusId
        : ""
    var applyFilter = {}
    applyFilter.page = pageChange ? pageCount : 1
    applyFilter.limit = 25
    if (searchCompany) {
      applyFilter.company = searchCompany
    }
    if (searchBranch) {
      applyFilter.branch = searchBranch
    }
    if (searchEmployee) {
      applyFilter.empCode = searchEmployee
    }
    if (searchDepartment) {
      applyFilter.department = searchDepartment
    }
    if (searchFromDate) {
      applyFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      applyFilter.toDate = searchToDate
    }
    if (searchStatus) {
      applyFilter.nightShiftStatus = searchStatus
    }

    setSearchValueList(applyFilter)
    setPageLoad(!pageLoad)
    console.log("searchCompany", applyFilter)
    specificDispatch(nightshiftAction.loadNightShiftDetail(applyFilter))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }
  //reset functionalities
  const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setDepartmentlist([])
    setEmployeeCode([])

    setNightShiftData({
      fromDate: "",
      toDate: "",
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    setSearchValueList({})
    setNightShiftStatus([])
    specificDispatch(
      nightshiftAction.loadNightShiftDetail({
        page: 1,
        limit: 25,
      })
    )
  }
  const [nightshiftId, setNightshiftId] = useState("")
  const [requestNo, setRequestNo] = useState("")
  const [deletemodal, setDeletemodal] = useState(false)
  // table data

  const [approvedData, setApprovedData] = useState("")

  // let slNo = 0
  const NightShiftDataTable = !isEmpty(nightshift_applies)
    ? nightshift_applies.data.map((nightshiftData, index) => {
        // slNo = slNo + 1

        // const dateFormate =
        //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

        console.log(dateFormate, "dateFormate")
        var nightShiftDate = !isEmpty(nightshiftData.date)
          ? moment(nightshiftData.date)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []
        var appliedDate = !isEmpty(nightshiftData.createdAt)
          ? moment(nightshiftData.createdAt)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []
        return {
          _id: nightshiftData._id,
          sNo: nightshiftData.seqNo,
          action: (
            <div className="d-flex flex-row">
              {shiftEditAccessId === "61bc3037e2e60e99196975fe" ? (
                <Button
                  type="submit"
                  onClick={() => {
                    setOpenModal(true)
                    editNightShiftDetails(nightshiftData)
                    setNightshiftId(nightshiftData._id)
                    setRequestNo(nightshiftData.requestNo)
                  }}
                  style={{ fontSize: "10px" }}
                  className="btn btn-success buttons"
                >
                  <i className="fas fa-pencil-alt icon-btn"></i>
                </Button>
              ) : (
                ""
              )}
              {shiftDeleteAccessId === "61bc3056e2e60e9919697601" ? (
                <Button
                  type="submit"
                  onClick={() => {
                    setDeletemodal(true)
                    deleteNightshiftDetails(nightshiftData)
                  }}
                  style={{ fontSize: "10px", marginLeft: "15px" }}
                  className="btn btn-danger buttons"
                >
                  <i className="fas fa-trash-alt icon-btn"></i>
                </Button>
              ) : (
                ""
              )}
              <>
                {shiftRoleAccessId === "63f346383a0fac2651611d92" ? (
                  <>
                    <button
                      onClick={() => {
                        editUpdateStatus(nightshiftData)
                        setRequestStatus(nightshiftData.status)
                      }}
                      className="btn btn-info"
                      style={{ padding: "6px 9.5px", marginLeft: "4px" }}
                    >
                      <i className="fas fa-shield-alt"></i>
                    </button>
                  </>
                ) : (
                  ""
                )}
              </>
            </div>
          ),
          attachments: "",
          branchId: nightshiftData.branchId,
          branchName: nightshiftData.branchName,
          companyId: nightshiftData.companyId,
          companyName: nightshiftData.companyName,
          client: nightshiftData.client,
          request: nightshiftData.request,
          date: nightShiftDate,
          createdAt: appliedDate,
          departmentId: nightshiftData.departmentId,
          departmentName: nightshiftData.departmentName,
          nightShiftStatus: nightshiftData.status,
          designationId: nightshiftData.designationId,
          designationName: nightshiftData.designationName,
          duration: nightshiftData.duration,
          employeeCode: nightshiftData.employeeCode,
          employeeName: nightshiftData.employeeName,
          fromTime: nightshiftData.fromTime,
          purpose: nightshiftData.purpose,
          toTime: nightshiftData.toTime,
          requestNo: nightshiftData.requestNo,
          volume: nightshiftData.volume,
          key: index,
          approvedBy: (
            <Button
              type="submit"
              onClick={() => {
                setRequestNo(nightshiftData.requestNo)
                setNightshiftId(nightshiftData._id)
                setApprovalView(true)
                setApprovedData(nightshiftData.request)
              }}
              style={{ fontSize: "10px" }}
              className="btn btn-info buttons"
            >
              <i className="fas fa-eye icon-btn"></i>
            </Button>
          ),
        }
      })
    : []
  //pagination table data columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "designationName",
      text: "Designation",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Code",
      sort: true,
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "date",
      text: "Date",

      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "fromTime",
      text: "Start Time",

      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "toTime",
      text: "End Time",

      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "client",
      text: "Client",
      headerStyle: {
        minWidth: "110px",
      },
    },
    {
      dataField: "volume",
      text: "Volume",

      headerStyle: {
        minWidth: "110px",
      },
    },
    {
      dataField: "purpose",
      text: "Purpose",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "nightShiftStatus",
      text: "Status",
      formatter: (cellContent, row) => {
        return (
          <button
            style={{ padding: "6px 10px" }}
            className={
              (row.nightShiftStatus === "Approved" &&
                "approved-btn disabled-button") ||
              (row.nightShiftStatus === "Pending" && "pending-btn") ||
              (row.nightShiftStatus === "Onhold" && "hold-btn") ||
              (row.nightShiftStatus === "Recheck" && "recheck-btn") ||
              (row.nightShiftStatus === "Rejected" && "reject-btn") ||
              (row.nightShiftStatus === "Accepted" && "accept-btn")
            }
          >
            {row.nightShiftStatus}
          </button>
        )
      },
      style: {
        color: "#e83e8c",
        cursor: "pointer",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "approvedBy",
      text: "Approved By",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "createdAt",
      text: "Applied Date",
      headerStyle: {
        minWidth: "170px",
      },
    },
  ]

  //Apply Delegation Details
  const applyDelegationDetails = () => {
    const applyNightShiftDetails = {
      empcode: empCodeData.empCode,
      company: nigthShiftApplyData.company,
      branch: nigthShiftApplyData.branch,
      department: nigthShiftApplyData.department,
      designation: nigthShiftApplyData.designation,
      client: nigthShiftApplyData.client,
      venue: nigthShiftApplyData.venue,
      volume: nigthShiftApplyData.volume,
      location: nigthShiftApplyData.location,
      date: moment(nigthShiftApplyData.permissionDate).format("YYYY-MM-DD"),
      fromtime: nigthShiftApplyData.fromTime,
      totime: nigthShiftApplyData.toTime,
      purpose: nigthShiftApplyData.purpose,
      filename: shiftAttachment[0],
    }
    specificDispatch(
      nightshiftAction.applyNightShiftList(applyNightShiftDetails)
    )
    setIsLoading(true)
    console.log(applyNightShiftDetails, "applyNightShiftDetails")
    setTimeout(() => {
      specificDispatch(nightshiftAction.loadNightShiftDetail(searchValue))
      // specificDispatch(leaveAction.loadLeaveList())
      toast.success("Nightshift Applied successfully")
      // handleShiftModal()
      setIsLoading(false)
      setApplyShiftModal(false)
    }, 2000)
  }

  const applyButton = () => {
    setEmpCodeData([])
    setNightShiftApplyData({
      company: "",
      branch: "",
      designation: "",
      department: "",
      toTime: "",
      fromTime: "",
      permissionDate: "",
      reason: "",
    })
    // setLeaveDuration([])
    // setLeaveStatusData([])
  }
  // Apply Permission Attachment
  const handleApplyLeaveAttachment = async (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var leaveAttachmentValue = shiftAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              leaveAttachmentValue.push(res.data.data)
              await setShiftAttachment(leaveAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }
  //modal data
  const [nightShiftModalData, setNightShiftModalData] = useState({
    _id: "",
    companyDetail: "",
    branchDetail: "",
    departmentDetail: "",
    designationDetail: "",
    date: "",
    employeeCodeDetail: "",
    clientDetail: "",
    fromTimeList: "",
    toTimeList: "",
    purposeDetail: "",
    status: [],
    volumeDetail: "",
    responseRemarks: "",
  })
  const modalChange = (e) => {
    setNightShiftModalData({
      ...nightShiftModalData,
      [e.target.name]: e.target.value,
    })
  }
  // edit button functionalities
  const [status, setStatus] = useState([])
  const editNightShiftDetails = (nightshift) => {
    //console.log(leave, "leave details from api list")

    setStatus({ label: nightshift.status, value: "" })
    setNightShiftModalData({
      ...nightShiftModalData,
      _id: nightshift._id,
      companyDetail: nightshift.companyName,
      branchDetail: nightshift.branchName,
      departmentDetail: nightshift.departmentName,
      designationDetail: nightshift.designationName,
      date: nightshift.date ? moment(nightshift.date).format("YYYY-MM-DD") : [],
      employeeCodeDetail: nightshift.employeeCode,
      clientDetail: nightshift.client,
      fromTimeList: nightshift.fromTime,
      toTimeList: nightshift.toTime,
      volumeDetail: nightshift.volume,

      purposeDetail: nightshift.purpose,
      status: [{ label: nightshift.status, value: "" }],

      responseRemarks: "",
    })
  }
  console.log("editnightshiftdetails", editNightShiftDetails)
  //update delegation details
  const deleteNightshiftDetails = (nightshiftData) => {
    setNightShiftModalData({ ...nightShiftModalData, _id: nightshiftData._id })
  }

  const updateNightShiftDetails = () => {
    const update_Nightshift = {
      empcode: nightShiftModalData.employeeCodeDetail,
      nightShiftId: nightshiftId,
      date: nightShiftModalData.date,
      purpose: nightShiftModalData.purposeDetail,
      fromtime: nightShiftModalData.fromTimeList,
      totime: nightShiftModalData.toTimeList,
      client: nightShiftModalData.clientDetail,
      nightShiftStatus: status ? status.processStatusId : "",
      latitude: "0",
      longitude: "0",
      filename: "",
      volume: nightShiftModalData.volumeDetail,
    }
    console.log(update_Nightshift, "update nightshift is ===========")
    dispatch(nightshiftAction.loadUpdateNightShift(update_Nightshift))
    setOpenModal(false)
    setTimeout(() => {
      specificDispatch(nightshiftAction.loadNightShiftDetail(searchValue))
      toast.success("Nightshift Updated Successfully")
    }, 2000)
  }
  //lpnd update
  const [lpndStatus, setLpndStatus] = useState(false)
  const handleLpnd = () => {
    setLpndStatus(false)
  }
  const [updateProcess, setUpdateProcess] = useState([])
  const [updateData, setUpdateData] = useState({
    _id: "",
    responseNotes: "",
    responseStatus: "",
    requestNo: "",
  })

  const updateChange = (e) => {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value })
  }

  //delete
  const deleteNightshift = () => {
    const deleteData = {
      nightShiftId: [nightShiftModalData._id],
      status: 3,
    }
    console.log(deleteData, "deleted")
    dispatch(nightshiftAction.deleteRecord(deleteData))
    setTimeout(() => {
      dispatch(nightshiftAction.loadNightShiftDetail(searchValue))
      toast.success("Nightshift Deleted successfully")
    }, 1000)
  }

  const editUpdateStatus = (nightshiftData) => {
    setUpdateProcess({ label: nightshiftData.status, value: "" })
    setLpndStatus(true)
    setUpdateData({
      ...updateData,
      _id: nightshiftData._id,
      responseNotes: "",
      responseStatus: [{ label: nightshiftData.status, value: "" }],
      requestNo: nightshiftData.requestNo,
    })
  }

  const updateLpndStatus = () => {
    const update_Lpnd = {
      _id: updateData._id,
      requesttype: "NightShift",
      status: updateProcess.processStatusId,
      note: updateData.responseNotes,
    }
    console.log("lpnd is", update_Lpnd)
    specificDispatch(nightshiftAction.updateLpndStatus(update_Lpnd))
    setTimeout(() => {
      specificDispatch(nightshiftAction.loadNightShiftDetail(searchValue))
      toast.success("Nightshift Updated successfully")
      setLpndStatus(false)
    })
  }

  const [approvalView, setApprovalView] = useState(false)
  const handleApprovalModal = () => setApprovalView(false)

  const title = "Night Shift"

  const [loading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  //Search filter
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)

    dispatch(
      nightshiftAction.loadNightShiftDetail({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 25,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const RemotePagination = ({
    data,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                            border: "none",
                            marginBottom: "20px",
                            marginTop: "-41px",
                          }}
                        >
                          <ReactHTMLTableToExcel
                            // id="download1"

                            table="ImportTable"
                            filename={"nightshift_import"}
                            className={
                              "download-table-xls-button btn btn-primary mx-2"
                            }
                            sheet="tablexls"
                            buttonText="Download"
                          />
                        </div>
                        {/* <ExportCSVButton
                          className="border float-right mx-10"
                          style={{
                            float: "right",
                            backgroundColor: "#e40d8c",
                            color: "#ffffff",
                          }}
                          {...props.csvProps}
                        >
                          Download{" "}
                        </ExportCSVButton>{" "} */}
                      </Col>
                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          columns={columns}
                          responsive
                          id="ImportTable"
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 25,
    page: 1,
  })
  const { sizePerPage, page } = state

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(departmentlist) ||
      !isEmpty(employeeCode) ||
      !isEmpty(nightShiftStatus) ||
      !isEmpty(NightShiftData.fromDate) ||
      !isEmpty(NightShiftData.toDate)
    ) {
      var searchCompany = companies && companies.value ? [companies.value] : ""
      var searchBranch  = branchValue
      var searchDepartment =
        departmentlist && departmentlist.value ? [departmentlist.value] : ""
      var searchEmployee =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
      var searchFromDate =
        NightShiftData && NightShiftData.fromDate ? NightShiftData.fromDate : ""
      var searchToDate =
        NightShiftData && NightShiftData.toDate ? NightShiftData.toDate : ""
      var searchStatus =
        nightShiftStatus && nightShiftStatus.processStatusId
          ? nightShiftStatus.processStatusId
          : ""
      var applyFilter = {}
      applyFilter.page = page
      applyFilter.limit = 25
      if (searchCompany) {
        applyFilter.company = searchCompany
      }
      if (searchBranch) {
        applyFilter.branch = searchBranch
      }
      if (searchEmployee) {
        applyFilter.empCode = searchEmployee
      }
      if (searchDepartment) {
        applyFilter.department = searchDepartment
      }
      if (searchFromDate) {
        applyFilter.fromDate = searchFromDate
      }
      if (searchToDate) {
        applyFilter.toDate = searchToDate
      }
      if (searchStatus) {
        applyFilter.nightShiftStatus = searchStatus
      }
      setPageLoad(!pageLoad)
      console.log("searchCompany", applyFilter)
      specificDispatch(nightshiftAction.loadNightShiftDetail(applyFilter))
    } else {
      dispatch(
        nightshiftAction.loadNightShiftDetail({
          page: page,
          limit: sizePerPage,
        })
      )
      setPageLoad(!pageLoad)
    }
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    setState(() => ({
      page,
      data: nightshift_applies,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Master"} breadcrumbItem={title} />
          <Row>
            <Col lg="12" md="12" sm="12" xs="12" className="mb-4">
              <div className="filter-buttons" style={{ float: "right" }}>
                <Button
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "#ffffff",
                    border: "none",
                    marginTop: "-20px",
                  }}
                  onClick={() => {
                    setApplyShiftModal(true)
                    applyButton()
                  }}
                >
                  Apply Nightshift
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="department"
                          value={departmentlist}
                          onChange={(e) => setDepartmentlist(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Employee Code"}
                          >
                            {"Employee Code"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="employeeCode"
                          key={resetManager}
                          items={employeeOptions}
                          value={employeeCode}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEmployeeCode(e)}
                          onChange={(e) => setEmployeeCode(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="fromDate"
                          value={NightShiftData.fromDate}
                          max={NightShiftData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="toDate"
                          value={NightShiftData.toDate}
                          min={NightShiftData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Nightshift Status"}
                          >
                            {"Nightshift Status"}
                          </Label>
                        </div>
                        <Select
                          name="nightShiftStatus"
                          value={nightShiftStatus}
                          onChange={(e) => setNightShiftStatus(e)}
                          options={nightshiftstatusOptions}
                          placeholder="Select Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => handleFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                          &nbsp; &nbsp;
                          <Button
                            type="reset"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={NightShiftDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={nightshift_applies.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
              {applyShiftModal && (
                <Modal
                  show={applyShiftModal}
                  onHide={handleShiftModal}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="6"
                      xs="6"
                      className="d-flex flex-row"
                    >
                      <span>APPLY NIGHTSHIFT</span>
                      {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
                    </Col>
                    {/* <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>SL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>CL :</span>
                      <h1 className="request-header"></h1>
                    </Col> */}
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label className="employee-label">Employee Code</Label>
                        <ReactSearchAutocomplete
                          name="empCodeData"
                          items={employeeCodeOptions}
                          value={empCodeData}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => employeeChange(e)}
                          onChange={(e) => employeeChange(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Company</Label>
                        <Input
                          name="company"
                          value={nigthShiftApplyData.company}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Company"
                          disabled
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Branch</Label>
                        <Input
                          name="branch"
                          value={nigthShiftApplyData.branch}
                          disabled
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Branch"
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Department</Label>
                        <Input
                          name="department"
                          value={nigthShiftApplyData.department}
                          disabled
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Department"
                        />
                      </Col>
                      <Col
                        xl="12"
                        lg="12"
                        md="12"
                        sm="3"
                        xs="3"
                        className="mt-2 mb-2"
                      >
                        <Row>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="d-flex flex-column"
                          >
                            {" "}
                            <Label className="employee-label">
                              Designation
                            </Label>
                            <Input
                              name="designation"
                              value={nigthShiftApplyData.designation}
                              disabled
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Enter Designation"
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-3">
                        <Label className="employee-label">Date</Label>
                        <Input
                          type="date"
                          name="permissionDate"
                          value={nigthShiftApplyData.permissionDate}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Select Date"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-3">
                        <Label className="employee-label">From Time</Label>
                        <Input
                          type="time"
                          name="fromTime"
                          value={nigthShiftApplyData.fromTime}
                          max={nigthShiftApplyData.toTime}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Select FromDate"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-3">
                        <Label className="employee-label">To Time</Label>
                        <Input
                          type="time"
                          name="toTime"
                          value={nigthShiftApplyData.toTime}
                          onChange={(e) => handleleaveChange(e)}
                          min={nigthShiftApplyData.fromTime}
                          placeholder="Select ToDate"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-3">
                        <Label className="employee-label">Client</Label>
                        <Input
                          type="text"
                          name="client"
                          value={nigthShiftApplyData.client}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter The Client"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-3">
                        <Label className="employee-label">Volume</Label>
                        <Input
                          type="text"
                          name="volume"
                          value={nigthShiftApplyData.volume}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter The Volume"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="6" lg="6" md="6" sm="6" xs="16" className="mt-2">
                        {" "}
                        <Label className="employee-label">Reason</Label>
                        <Input
                          type="textarea"
                          name="purpose"
                          value={nigthShiftApplyData.purpose}
                          onChange={(e) => handleleaveChange(e)}
                          // disabled
                          placeholder="Enter purpose"
                          className="employee-crowd-textarea"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="mt-2 d-flex flex-column"
                      >
                        {" "}
                        <Label className="employee-label">
                          Attachment File
                        </Label>
                        <Input
                          type="file"
                          name="shiftAttachment"
                          // value={shiftAttachment}
                          multiple
                          onChange={(e) => handleApplyLeaveAttachment(e)}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleShiftModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        setConfirmModalView(true)
                        // handleShiftModal()
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {confirmModalView && (
                <Modal
                  show={confirmModalView}
                  onHide={handleConfirmModal}
                  backdrop="static"
                  keyboard={false}
                  style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>Apply NightShift</span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure, you want to apply for the NightShift?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleConfirmModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleConfirmModal()
                        applyDelegationDetails()
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {openModal && (
                <Modal show={openModal} onHide={handleModal} size="lg">
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="6"
                      xs="6"
                      className="d-flex flex-column"
                    >
                      <span>REQUEST NO:{requestNo}</span>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>SL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>CL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Company</Label>
                        <Input
                          type="text"
                          name="companyDetail"
                          value={nightShiftModalData.companyDetail}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Select company"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Branch</Label>
                        <Input
                          type="text"
                          name="branchDetail"
                          value={nightShiftModalData.branchDetail}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Enter Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Department</Label>
                        <Input
                          type="text"
                          name="departmentDetail"
                          value={nightShiftModalData.departmentDetail}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Enter Department"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Designation</Label>
                        <Input
                          type="text"
                          name="designationDetail"
                          value={nightShiftModalData.designationDetail}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Enter Designation"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        <Label className="employee-label">Employee Code</Label>
                        <Input
                          type="text"
                          name="employeeCodeDetail"
                          value={nightShiftModalData.employeeCodeDetail}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Enter EmployeeCode"
                        />
                      </Col>

                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        {" "}
                        <Label className="employee-label">Date</Label>
                        <Input
                          type="date"
                          name="date"
                          value={nightShiftModalData.date}
                          onChange={(e) => modalChange(e)}
                          placeholder="Select Status"
                        />
                      </Col>

                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        <Label className="employee-label">Start Time</Label>
                        <Input
                          type="time"
                          name="fromTimeList"
                          max={nightShiftModalData.toTimeList}
                          value={nightShiftModalData.fromTimeList}
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Time"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        <Label className="employee-label">End Time</Label>
                        <Input
                          type="time"
                          name="toTimeList"
                          min={nightShiftModalData.fromTimeList}
                          value={nightShiftModalData.toTimeList}
                          onChange={(e) => modalChange(e)}
                          placeholder="Select Company"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        <Label className="employee-label">Client</Label>
                        <Input
                          type="text"
                          name="clientDetail"
                          value={nightShiftModalData.clientDetail}
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Client"
                        />
                      </Col>

                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        <Label className="employee-label">Volume</Label>
                        <Input
                          type="text"
                          name="volumeDetail"
                          value={nightShiftModalData.volumeDetail}
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Volume"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="6" lg="6" md="6" sm="6" xs="16" className="mt-2">
                        {" "}
                        <Label className="employee-label">Purpose</Label>
                        <Input
                          type="textarea"
                          name="purposeDetail"
                          value={nightShiftModalData.purposeDetail}
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Description"
                          className="employee-crowd-textarea"
                        />
                      </Col>
                      <Col xl="6" lg="6" md="6" sm="6" xs="6" className="mt-2">
                        {" "}
                        <Label className="employee-label">
                          Response Remarks
                        </Label>
                        <Input
                          type="textarea"
                          name="responseRemarks"
                          value={nightShiftModalData.responseRemarks}
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Response Remarks"
                          className="employee-crowd-textarea"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="12"
                        xs="12"
                        className="mt-2"
                      >
                        {" "}
                        <Label className="employee-label">Status</Label>
                        <Select
                          type="text"
                          name="status"
                          value={status}
                          onChange={(e) => setStatus(e)}
                          placeholder="Select Status"
                          options={processStatusOptions}
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => updateNightShiftDetails()}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {lpndStatus && (
                <Modal show={lpndStatus} onHide={handleLpnd}>
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>REQUEST NO: {updateData.requestNo}</span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <Col>
                      <Row className="d-flex flex-column">
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column"
                        >
                          <Label className="employee-label">
                            Response Notes
                          </Label>
                          <Input
                            type="textarea"
                            name="responseNotes"
                            value={updateData.responseNotes}
                            onChange={(e) => updateChange(e)}
                            placeholder="Enter Response Notes"
                            className="employee-crowd-textarea"
                          />
                        </Col>
                        <Col
                          xl="6"
                          lg="6"
                          md="6"
                          sm="12"
                          xs="12"
                          className="mt-2"
                        >
                          <Label className="event-label">Response Status</Label>
                          <Select
                            type="text"
                            name="updateProcess"
                            value={updateProcess}
                            options={updateProcessStatusOptions}
                            onChange={(e) => setUpdateProcess(e)}
                            placeholder="Select response status"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleLpnd}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleLpnd()
                        updateLpndStatus()
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {approvalView && (
                <Modal
                  show={approvalView}
                  onHide={handleApprovalModal}
                  size="lg"
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>REQUEST NO:{requestNo}</span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <Col>
                      <Row className="d-flex flex-column">
                        {/* <div>No Records Found</div> */}
                        <Col xl="12" lg="12" md="12" sm="12" xs="12">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th style={{ width: "20px" }}>S.No</th>
                                <th style={{ width: "70px" }}>Approved By</th>
                                <th style={{ width: "70px" }}>Approved On</th>
                                <th style={{ width: "70px" }}>Notes</th>
                                <th style={{ width: "50px" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {approvedData.map((nightShift, index) => {
                                // let slNo = 0
                                console.log(
                                  nightShift,
                                  "request from data table leave"
                                )
                                const dateFormate =
                                  !isEmpty(dateSetting) && dateSetting
                                    ? dateSetting
                                    : ""

                                console.log(dateFormate, "dateFormate")
                                return (
                                  <tr key={nightShift._id}>
                                    <td>{index + 1}</td>
                                    <td>{nightShift.approvedByName}</td>
                                    <td>
                                      {moment(nightShift.aprovedDate).format(
                                        dateFormate
                                      )}
                                    </td>
                                    <td>{nightShift.notes}</td>
                                    <td>{nightShift.status}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleApprovalModal}
                    >
                      Cancel
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </Col>
          </Row>
          {deletemodal && (
            <Modal
              show={deletemodal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Delete Permission</span>
                </div>
              </Modal.Header>
              <Modal.Body>
                Are you sure, you want to Delete the Permission Details?
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      deleteNightshift()
                      setDeletemodal(false)
                    }}
                    style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Yes{" "}
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setDeletemodal(false)
                    }}
                    style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    No{" "}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {isLoading ? (
            <Modal show={isLoading} style={{ width: "6%", margin: "20% 50%" }}>
              <Modal.Body className="d-flex flex-column">
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2 mb-2"
                />
                <span>Loading...</span>
                {/* <span>Response Successfully Updated</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {btnLoading ? (
            <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

NightShiftDetails.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NightShiftDetails)
)
